import { getCookie, setCookie } from '../utils/cookies-utils.js';

export default function () {
  const newsletterCookieName = "camsoNewsletterPopup";
  const dialogEl = document.querySelector("#newsletter-popup");

  if(!dialogEl) return;

  const closeBtns = dialogEl.querySelectorAll(".newsletter-popup-close-btn");

  if(!getCookie(newsletterCookieName)) {
    dialogEl.showModal();
    document.querySelector('body').classList.add('overflow-hidden');
    setCookie(newsletterCookieName, 1, 30);

    closeBtns.forEach(btn => {
      btn.addEventListener("click", () => {
        dialogEl.close();
      });
    });

    dialogEl.addEventListener('close', () => {
      document.querySelector('body').classList.remove('overflow-hidden');
    });
  }
}
